console.log('🚀 Frontend Build: 20250203-v2.10 - Fixed all currency formatting (dollars not cents)');
